import { render } from "./StockTransferList.vue?vue&type=template&id=587c8a06&scoped=true"
import script from "./StockTransferList.vue?vue&type=script&lang=js"
export * from "./StockTransferList.vue?vue&type=script&lang=js"

import "./StockTransferList.vue?vue&type=style&index=0&id=587c8a06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587c8a06"]])

export default __exports__